import React, { createContext, useContext } from "react";

/* -----------------------------------------------------------------------------
 * AppContext — shares the entire App-level state (auth, catalog, admin state,
 * handlers) with the extracted page components (AdminPage, StoreDetailPage,
 * AppModals, …) so we can split the previously monolithic App.js into files
 * without introducing prop-drilling of ~120 handlers.
 *
 * The Provider is instantiated in App.js with a value bag containing every
 * piece of state + every handler defined at that level. Consumer pages call
 * `useAppContext()` to pull whatever they need.
 * --------------------------------------------------------------------------- */
const AppContext = createContext(null);

export function AppProvider({ value, children }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (ctx == null) {
    throw new Error("useAppContext must be used inside <AppProvider>");
  }
  return ctx;
}
